import { Select } from "ant-design-vue";

const selectFixPlugin = {
  install(app) {
    app.component("a-select", {
      ...Select,
      props: {
        ...Select.props,
        getPopupContainer: {
          type: Function,
          default: (triggerNode) => triggerNode?.ownerDocument?.body || document.body,
        },
      },
    });
  },
};

export default selectFixPlugin;
